import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

export interface UpdateNotesBody {
  editedSummary: string;
}

export const useUpdateNotes = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useMutation({
    mutationFn: async ({
      clinicalNoteId,
      updateNotesBody,
    }: {
      clinicalNoteId: string;
      updateNotesBody: UpdateNotesBody;
    }) => {
      return makeAPIRequestReactQuery(
        `/videa-notes/${clinicalNoteId}/summary`,
        {},
        'patch',
        {
          data: updateNotesBody,
          headers: {
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
  });
};
